import { parseUTCDateTimeFromString } from "@app/utils/utils";

import { getRelativeTimestamp } from "./datetime";
import { SessionNote } from "../types";

export const populateTimestamps = (
  notes: SessionNote[],
  sessionStartTime: string,
  videoOffset?: number
): SessionNote[] => {
  const sessionStartDateTime = parseUTCDateTimeFromString(sessionStartTime);
  return notes.map((note) => ({
    ...note,
    relativeStartTime: note.startTime
      ? note.startTime
          .diff(sessionStartDateTime)
          .plus({ seconds: videoOffset ?? 0 })
          .as("seconds")
      : undefined,
    timestamp: note.startTime
      ? getRelativeTimestamp(sessionStartDateTime, note.startTime)
      : undefined,
  }));
};
